import request from '@hb/sharp-request';
import { newGatewayUrl } from '@/constant';

// 用户是否有首期免息券
export const getHaveCoupon = (productId?: string): Promise<boolean> => request.postGate(
  'f.loan.invite.haveNotExpiredCoupon',
  {
    productId,
  },
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
  },
);

// 是否参加首提活动
export const getFirstActive = (actCode: string): Promise<boolean> => request.postGate(
  'f.loan.invite.canParticipate',
  {
    actCode,
  },
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
  },
);

const FirstActiveApi = {
  getHaveCoupon,
  getFirstActive,
};

export default FirstActiveApi;
